import EpicGamesFooter from 'epic-games-footer/app/scripts/EpicGamesFooter';
import Immutable from 'seamless-immutable';
import PropTypes from 'prop-types';
import React from 'react';
import {generateRoutePath} from '@epic-core/common';
import root from 'window-or-global';
import {withRouter} from 'react-router';

class EpicGamesFooterWrapper extends React.PureComponent {
    static propTypes = {
        loginStore: PropTypes.object,
        history: PropTypes.object.isRequired,
        footerStore: PropTypes.object,
        localizationStore: PropTypes.object,
        upOnClick: PropTypes.func
    };

    /**
     * Routes to link's href
     * @param {Object} link
     */
    addOnClick(link, history) {
        if (link && link.href) {
            link.onClick = (e) => {
                e.preventDefault();
                e.stopPropagation();
                //Open page directly when click external link
                if (link.href.indexOf('/') === 0) {
                    history.push(generateRoutePath(link.href));
                } else {
                    root.location = link.href;
                }
            };
        }
        return Immutable(link);
    }

    /**
     * Prepares the array of links for the footer
     * @param {array} links
     */
    setLinks(links) {
        const {history} = this.props;
        links.forEach((link) => {
            this.addOnClick(link, history);
        });
        return Immutable(links);
    }

    render() {
        const { upOnClick } = this.props;
        const loginStore = this.props.loginStore || {};
        const config = this.props.footerStore.config ? this.props.footerStore.config.asMutable({deep: true}) : {};
        const epicPropertyName = config.epicPropertyName || 'unrealtournament';
        const links = this.setLinks(config.links || []);
        const accountInfo = this.props.loginStore ? this.props.loginStore.accountInfo || {} : {};
        const email = accountInfo.email || '';
        const localizationStore = this.props.localizationStore || {};
        const msg = localizationStore.messages || {};

        return (
            <div id="footerSection" className="section fp-auto-height">
                <EpicGamesFooter
                    epicPropertyName={epicPropertyName}
                    isLoggedIn={loginStore.isLoggedIn}
                    links={links}
                    socialLinks={config.socialLinks || []}
                    copyrights={config.copyrights || []}
                    legalTags={config.legalTags || []}
                    logos={config.logos || []}
                    messages={config.messages || []}
                    newLineCopyrights={config.newLineCopyrights}
                    newsLetterConfigs={config.newsLetterConfigs || {}}
                    enableNewsLetter={config.enableNewsLetter || false}
                    i18n={msg}
                    email={email}
                    upOnClick={upOnClick && upOnClick} />
                    
            </div>
        );
    }
}

export default withRouter(EpicGamesFooterWrapper);
